import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';


//localstorage get access token
const local_access_token = localStorage.getItem('access_token');
const access_token = JSON.parse(local_access_token);
//----------------------------------------------------------------------


//Get contract list by wallet
export const getContract = createAsyncThunk("contract/getContract", async ({address}) => {
    return fetch(`${process.env.REACT_APP_API_URL}/api/contract`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            'Authorization': `Bearer ${access_token.token}`,
            "x-auth-wallet": address,
        },
    }).then((res) => 
    res.json()
    );
})

//-----------------------------------------------------------------------------------------------------

//Get gated by Id for NFTs
export const getContractId = createAsyncThunk("contract/getContractId", async ({id}) => {
    return fetch(`${process.env.REACT_APP_API_URL}/api/contract/${id}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        },
    }).then((res) => 
    res.json()
    );
})


//-----------------------------------------------------------------------------------------------------

//Post request to create contract
export const createContract = createAsyncThunk("contract/createContract", async ({contractData}) => {
    return fetch(`${process.env.REACT_APP_API_URL}/api/contract/create`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            'Authorization': `Bearer ${access_token.token}`,
        },
        body: JSON.stringify({
            wallet: contractData.wallet,
            name: contractData.name,
            symbol: contractData.symbol,
            contentImageUrl: contractData.contentImageUrl,
            supply: contractData.supply,
            fee: contractData.fee,
            type: contractData.type,
            contractAddress: contractData.contractAddress,
            chains: contractData.chains,
            trusted: contractData.trusted,
            mint: contractData.mint,
        })
    }).then((res) => 
    res.json()
    );
})




//Updaate contract details
export const updateContract = createAsyncThunk("contract/updateContract", async ({contractData, id}) => {
    return fetch(`${process.env.REACT_APP_API_URL}/api/contract/update/${id}`, {
        method: "PUT",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            'Authorization': `Bearer ${access_token.token}`,
        },
        body: JSON.stringify({
            wallet: contractData.wallet,
            name: contractData.name,
            symbol: contractData.symbol,
            contentImageUrl: contractData.contentImageUrl,
            supply: contractData.supply,
            fee: contractData.fee,
            type: contractData.type,
            contractAddress: contractData.contractAddress,
            chains: contractData.chains,
            trusted: contractData.trusted,
            mint: contractData.mint,
        })
    }).then((res) => 
    res.json()
    );
})


//Get quick mint list by wallet
export const getQuickMint = createAsyncThunk("contract/getQuickMint", async ({address}) => {
    return fetch(`${process.env.REACT_APP_API_URL}/api/mint`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            'Authorization': `Bearer ${access_token.token}`,
            "x-auth-wallet": address,
        },
    }).then((res) => 
    res.json()
    );
})

//Post request for quick minting
export const quickMint = createAsyncThunk("contract/quickMint", async ({mintData}) => {
    return fetch(`${process.env.REACT_APP_API_URL}/api/mint/mint`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            'Authorization': `Bearer ${access_token.token}`,
        },
        body: JSON.stringify({
            name: mintData.name,
            description: mintData.description,
            contentImageUrl: mintData.contentImageUrl,
            external_url: mintData.external_url,
            creator: mintData.creator,
            tokenID: mintData.tokenID,
            contractAddress: mintData.contractAddress,
            amount: mintData.amount,
            metadata: mintData.metadata,
            contractType: mintData.contractType,
            chains: mintData.chains
        })
    }).then((res) => 
    res.json()
    );
})



const contractSlice = createSlice({
    name: "contract",
    initialState: {
        contract: [],
        quickMint: [],
        updateContract: [],
        details: null,
        loading: false,
        loadingUpdate: false,
        error: null,
    },


    extraReducers: {

        //get all contract list
        [getContract.pending]: (state, action) => {
            state.loading = true;
        },
        [getContract.fulfilled]: (state, action) => {
            state.loading = false;
            state.contract = [action.payload];
        },
        [getContract.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },


        //get by contract Id
        [getContractId.pending]: (state, action) => {
            state.loading = true;
        },
        [getContractId.fulfilled]: (state, action) => {
            state.loading = false;
            state.details = [action.payload];
        },
        [getContractId.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        

        //post contract
        [createContract.pending]: (state, action) => {
            state.loading = true;
        },
        [createContract.fulfilled]: (state, action) => {
            state.loading = false;
            state.contract = action.payload;
        },
        [createContract.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },


        //update contract
        [updateContract.pending]: (state, action) => {
            state.loadingUpdate = true;
        },
        [updateContract.fulfilled]: (state, action) => {
            state.loadingUpdate = false;
            state.updateContract = action.payload;
        },
        [updateContract.rejected]: (state, action) => {
            state.loadingUpdate = false;
            state.error = action.payload;
        },

        //get all mint list by wallet
        [getQuickMint.pending]: (state, action) => {
            state.loading = true;
        },
        [getQuickMint.fulfilled]: (state, action) => {
            state.loading = false;
            state.quickMint = [action.payload];
        },
        [getQuickMint.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },


        //post quick mint
        [quickMint.pending]: (state, action) => {
            state.loading = true;
        },
        [quickMint.fulfilled]: (state, action) => {
            state.loading = false;
            state.quickMint = action.payload;
        },
        [quickMint.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        
    }
})


export default contractSlice.reducer;